export const CARD_DIALOG_MODE = {
  VIEW_MODE: 'viewMode',
  EDIT_MODE: 'editMode',
};

export const CARD_SOURCE = {
  FACEBOOK: 'facebook',
  SMARTPAGE: 'smartpage',
};

export const softLimit = 200;
export const hardLimit = 500;
